import { render } from "./LogoHaikara.vue?vue&type=template&id=3447914c&scoped=true"
import script from "./LogoHaikara.vue?vue&type=script&lang=js"
export * from "./LogoHaikara.vue?vue&type=script&lang=js"

import "./LogoHaikara.vue?vue&type=style&index=0&id=3447914c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3447914c"]])

export default __exports__